<section class="order-status-page">
  <div class="section-banner">
    <div class="container">
      <div class="wrap-text">
        <div class="status-image">
          <i class="fas fa-check-circle"></i>
        </div>
        <div class="right-text">
          <h1>Order Successful</h1>
          <p *ngIf="!this.transactionData?.microProduct" class="small-text">
            You have total <strong>1 items</strong>
          </p>
          <p *ngIf="this.transactionData?.microProduct" class="small-text">
            You have total
            <strong>{{ this.transactionData?.items?.length }} items</strong>
          </p>
          <button
            class="btn btn-outline-light btn-white-bg"
            [routerLink]="['/account/profile']"
          >
            Go to My Account
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-transaction-layout></app-transaction-layout>
</section>
